
import React, { useMemo } from 'react'
import {
  Button,
  FormDashboardLabel as Label,
  FormDashboardInput as Input,
  User,
  Table,
} from '../../../components'
import { useViewport, viewportBreakpoint } from '../../../utils'

const TeamTable = () => {
  const tableData = useMemo(
    () => [
      {
        name: 'Jawad Mughofar',
        location: 'Bandung',
      },
      {
        name: 'Irfan Amali',
        location: 'Bandung',
      },
      {
        name: 'Dina Annisa',
        location: 'Aceh',
      },
      {
        name: 'Taufiq Akbar',
        location: 'Bandung',
      },
    ],
    []
  )
  const tableColumns = useMemo(
    () => [
      {
        accessor: 'name',
        Cell: ({ value }) => (
          <User small name={value} />
        )
      },
      {
        accessor: 'location',
      },
      {
        id: 'action',
        Cell: () => (
          <button className="cursor-pointer underline text-sm text-gray-999">
            Delete
          </button>
        )
      }
    ],
    []
  )

  return (
    <Table
      data={tableData}
      columns={tableColumns}
      noHeader
      withPagination={false}
    />
  )
}

const ContentOfficialTeam = () => {
  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet

  return (
    <div className="xl:w-2/3">
      <form>
        <p className="text-lg font-bold mb-5 lg:mb-8">Team Member</p>
        <div className="mb-8">
          <Label>Address</Label>
          <div className="w-full flex flex-col md:flex-row items-center">
            <Input defaultValue="Indahmunaf@gmail.com" className="mr-2 w-full mb-5 md:mb-0"/>
            <Button
              style={{maxWidth: isMobile ? '100%' : '137px'}}
              thin
              className="w-full lg:w-auto h-full whitespace-no-wrap"
            >
              Add Member
            </Button>
          </div>
        </div>
        <div className="mb-8">
          <Label>Members</Label>
          <div className="mobile-fullwidth">
            <TeamTable />
          </div>
        </div>
      </form>
    </div>
  )
}

export { ContentOfficialTeam }
